import {
  AddButton,
  ButtonGroup,
  Button,
  LinkButton,
} from 'components/atoms/button';
import { TertiaryButton } from 'components/atoms/tertiary-button';
import { withAccess } from 'hooks/rbac/withAccess';

export const RbacButton = withAccess(Button);
export const RbacTertiaryButton = withAccess(TertiaryButton);
export const RbacAddButton = withAccess(AddButton);
export const RbacLinkButton = withAccess(LinkButton);
export const RbacButtonGroup = withAccess(ButtonGroup);
